import { render, staticRenderFns } from "./yujingbaojingqingkuang.vue?vue&type=template&id=96d388f4&scoped=true"
import script from "./yujingbaojingqingkuang.vue?vue&type=script&lang=js"
export * from "./yujingbaojingqingkuang.vue?vue&type=script&lang=js"
import style0 from "./yujingbaojingqingkuang.vue?vue&type=style&index=0&id=96d388f4&prod&lang=scss"
import style1 from "./yujingbaojingqingkuang.vue?vue&type=style&index=1&id=96d388f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d388f4",
  null
  
)

export default component.exports